<template>
	<div class="container personal-data">
        <div class="row">
            <div class="col-4 icon-master">
                <i class="fa fa-map-marker-alt"></i>
            </div>

            <div class="col-8">
                <div class="headline h2 tc">
                    <span>Wo soll die Nachhilfe sattfinden?</span>
                </div>
                
                <vue-google-autocomplete
                    id="map"
                    ref="address"
                    classname="form-control"
                    placeholder="Strasse, Ort"
                    v-on:placechanged="getAddressData"
                    country="de"
                    v-if="!autocompleteSelected"
                    >
                </vue-google-autocomplete>
                <div class="row" v-if="autocompleteSelected" >
                    <div class="input-group col-8" >
                        <input v-model="route" placeholder="Strasse" v-validate="'required'" >
                    </div>
                    <div class="input-group col-4">
                        <input v-model="street_number" placeholder="Hausnummer" v-validate="'required'" >
                    </div>
                    <div class="input-group col-4">
                        <input v-model="postal_code" placeholder="Postleitzahl" v-validate="'required|numeric'" >
                    </div> 
                    <div class="input-group col-8">
                        <input v-model="locality" placeholder="Ort" v-validate="'required'" >
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
	name: 'personalData',
	components: {
		VueGoogleAutocomplete
	},

	data: function () {
        return {
          address: '',
          street_number: '',
          postal_code: '',
          route: '',
          locality: '',
          autocompleteSelected: false,
        }
    },

    mounted() {
        this.$refs.address.focus();
    },

    methods: {
        getAddressData: function (addressData) {
            this.autocompleteSelected = true;
            this.address = addressData;
            this.route = addressData.route;
            this.postal_code = addressData.postal_code;
            this.locality = addressData.locality;
            this.street_number = addressData.street_number;
        },

        nextPage() {
            if(!this.autocompleteSelected) {
                this.$modal.show('dialog', {
                  title: 'Feld erforderlich',
                  text: 'Du musst eine Adresse eingeben und dann einen Eintrag aus dem Auswahlmenü wählen.',
                  buttons: [
                  {
                    title: 'Okay'
                  }
                  ]
                })
            } else {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Success
                        this.$emit('openNextPage', this);
                        return;
                    }
                    if(!result){
                        // Error
                        console.log(this);                
                    }
                });
            }
        }
    }
}
</script>
